export default "__VITE_ASSET__BU5uckcf__"